import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "bootstrap/dist/js/bootstrap.bundle.min";

const DynamicFaqs = ({faqsDynamicContent}) => {
  // Use an object to track which FAQ is open
  const [openFaqs, setOpenFaqs] = useState({});
  const [showMore, setShowMore] = useState(false);


  const handleFaq = (index) => {
    setOpenFaqs((prev) => ({
      ...prev,
      [index]: !prev[index], // Toggle the state for this particular FAQ
    }));
  };
  const faqsToShow = showMore ? faqsDynamicContent : faqsDynamicContent.slice(0, 5);

  return (
    <>
      <div className="mt-3">
        {faqsToShow.map((item, index) => (
          <div key={index}>
            <p
              className="p-3 rounded d-flex align-items-center justify-content-between fw-normal" 
              id="bgFaqs"
              onClick={() => handleFaq(index)}
            >
              {item.question}
              {openFaqs[index] ? (
                <Icon
                  icon="proicons:subtract"
                  width="24"
                  height="24"
                  style={{ color: "#fff" }}
                />
              ) : (
                <Icon
                  icon="proicons:add"
                  width="32"
                  height="32"
                  style={{ color: "#fff" }}
                />
              )}
            </p>
            {openFaqs[index] && <p className="m-2 pb-3">{item.answer}</p>}
          </div>
          
        ))}
        <button 
                onClick={() => setShowMore(prev => !prev)} 
                id="btnCTA"
            >
                {showMore ? 'View Less' : 'View More'}
            </button>
      </div>
      
    </>
  );
};

export default DynamicFaqs;
